import axios from "axios";
import { convertStringstoDates } from "../utils/dateFormatters.ts";

const apiUrl = import.meta.env.VITE_QZ_MONOLITH_URL;

const apiClient = axios.create({
  baseURL: apiUrl,
  headers: { "Content-Type": "application/json", Accept: "application/pdf" },
});

// Request Interceptor to add the access token to the headers
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("authToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    } else {
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

apiClient.interceptors.response.use(
  (response) => {
    // Transform dates in the response data
    response.data = convertStringstoDates(response.data);
    return response;
  },
  async (error) => {
    const originalRequest = error.config;

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      const refreshToken = localStorage.getItem("refreshToken");

      if (!refreshToken) {
        // No refresh token available, redirect to login immediately
        localStorage.removeItem("authToken");
        window.location.href = "/login";
        return Promise.reject("No refresh token available");
      }

      try {
        const { data } = await axios.post(
          `${apiUrl}/auth/refresh-token`,
          { refreshToken },
          { headers: { "Content-Type": "application/json" } }
        );

        localStorage.setItem("authToken", data.access_token);
        if (data.refresh_token) {
          localStorage.setItem("refreshToken", data.refresh_token);
        }

        apiClient.defaults.headers.common[
          "Authorization"
        ] = `Bearer ${data.access_token}`;
        originalRequest.headers[
          "Authorization"
        ] = `Bearer ${data.access_token}`;

        return apiClient(originalRequest);
      } catch (refreshError) {
        // Clear auth data and redirect to login
        localStorage.removeItem("authToken");
        localStorage.removeItem("refreshToken");
        window.location.href = "/login";
        return Promise.reject("Authentication failed");
      }
    }

    return Promise.reject(
      error.response?.data?.message || "An unexpected error occurred."
    );
  }
);

export default apiClient;
